import { render, staticRenderFns } from "./commonSlide.vue?vue&type=template&id=12d292e5&scoped=true"
import script from "./commonSlide.vue?vue&type=script&lang=js"
export * from "./commonSlide.vue?vue&type=script&lang=js"
import style0 from "./commonSlide.vue?vue&type=style&index=0&id=12d292e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d292e5",
  null
  
)

export default component.exports